import { render, staticRenderFns } from "./purchase-plan-bulk-action-success.vue?vue&type=template&id=1a635b16&scoped=true&"
import script from "./purchase-plan-bulk-action-success.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-bulk-action-success.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-bulk-action-success.vue?vue&type=style&index=0&id=1a635b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a635b16",
  null
  
)

export default component.exports